import { Component } from '@angular/core';
import { MatLegacyDialogRef as MatDialogRef } from '@angular/material/legacy-dialog';

import { IValueLabel } from 'v2/modules/shared';

@Component({
  selector: 'lum-tags-autocomplete-chip-dialog',
  templateUrl: './tags-autocomplete-chip-dialog.component.html',
  styleUrls: ['./tags-autocomplete-chip-dialog.component.scss'],
})
export class TagsAutocompleteChipDialogComponent {
  constructor(
    public dialogRef :MatDialogRef<TagsAutocompleteChipDialogComponent>,
  ) {}
  selectedItems :IValueLabel[] = [];
  onSelectedChangeEvent(items :IValueLabel[]) :void {
    this.selectedItems = items;
  }

  onSubmit() :void {
    this.dialogRef.close(this.selectedItems);
  }
}
